import './Admin.css'
import React, { useEffect } from 'react'
import {Modal, Button, Form} from 'react-bootstrap'
import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Spinner from 'react-bootstrap/Spinner';
import baseUrl from '../api'


function AdminView(props) {

    const [refreshTrigger, setRefreshTrigger] = useState(0);
    
    const triggerRefresh = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <div id='viewContainer'>
            <div id='welcomeContainer'>
                <h3>Admin</h3>
            </div>
            <div className='formContainer'>
                <AddUserForm profile={props.profile} onUserAdded={triggerRefresh}/>
                <AddZoomUserForm profile={props.profile} onUserAdded={triggerRefresh}/>
            </div>
            <div id='usersContainer'>
                <AllZoomUsersList profile={props.profile} refreshTrigger={refreshTrigger}/>
                <AllUsersList profile={props.profile} refreshTrigger={refreshTrigger}/>
            </div>
        </div>
    );
}

function AddUserForm(props) {

    // New states for the new fields
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('BASIC'); // default to 'basic'
    const [loading, setLoading] = useState(false);

    // Handlers for the new fields
    const handleFirstNameChange = (e) => setFirstName(e.target.value);
    const handleLastNameChange = (e) => setLastName(e.target.value);
    const handleEmailChange = (e) => setEmail(e.target.value);
    const handleRoleChange = (e) => setRole(e.target.value);

    function addUser() {

        setLoading(true);

        if(firstName === '') {
            alert('Please enter a first name.');
            return;
        }
        if(lastName === '') {
            alert('Please enter a last name.');
            return;
        }
        if(email === '') {
            alert('Please enter an email.');
            return;
        }

        const url = baseUrl + '/api/users/';
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('uid', props.profile.uid);
        
        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "uid": email,
                "firstName": firstName,
                "lastName": lastName,
                "email": email,
                "role": role
            })
        };

        fetch(url, requestOptions)
            .then(response => {
                setLoading(false); // Reset loading state
                if (response.status === 201) {
                    alert('User added successfully.');
                    props.onUserAdded();
                } else {
                    alert('Error adding user.');
                }
            })
            .catch(error => {
                setLoading(false); // Reset loading state
                console.log(error);
            });
    }

    return (
        <div className="addUserForm">
            <Form>
                <h3>Add User</h3>

                <Form.Group controlId="firstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter first name"
                        value={firstName}
                        onChange={handleFirstNameChange}
                    />
                </Form.Group>

                <Form.Group controlId="lastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter last name"
                        value={lastName}
                        onChange={handleLastNameChange}
                    />
                </Form.Group>

                <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={handleEmailChange}
                    />
                </Form.Group>

                <fieldset>
                    <Form.Group>
                        <Form.Label as="legend">Role</Form.Label>
                        <Form.Check
                            type="radio"
                            label="Basic"
                            name="roleOptions"
                            id="roleBasic"
                            value="BASIC"
                            checked={role === 'BASIC'}
                            onChange={handleRoleChange}
                        />
                        <Form.Check
                            type="radio"
                            label="Admin"
                            name="roleOptions"
                            id="roleAdmin"
                            value="ADMIN"
                            checked={role === 'ADMIN'}
                            onChange={handleRoleChange}
                        />
                    </Form.Group>
                </fieldset>
            </Form>
            <Button className='saveButton' variant="dark" onClick={addUser}>
                Save
            </Button>
            <Spinner id='spinner' animation="border" role="status" hidden={!loading}> </Spinner>
        </div>
    );
} 

function AddZoomUserForm(props) {
    const [loading, setLoading] = useState(false);

    // States for the new fields
    const [participantLimit, setParticipantLimit] = useState('100'); // default to '100'
    const [customParticipantLimit, setCustomParticipantLimit] = useState(''); // for custom input
    const [email, setEmail] = useState('');
    const [hostKey, setHostKey] = useState(''); // New state for host key

    // Handlers for the new fields
    const handleEmailChange = (e) => setEmail(e.target.value);
    const handleHostKeyChange = (e) => setHostKey(e.target.value);
    const handleParticipantLimitChange = (e) => {
        setParticipantLimit(e.target.value);
        if (e.target.value !== 'custom') {
            setCustomParticipantLimit(''); // Reset custom limit if not selected
        }
    };
    const handleCustomParticipantLimitChange = (e) => setCustomParticipantLimit(e.target.value);

    function addZoomUser() {
        const url = baseUrl + '/api/zoomusers/';
        const headers = new Headers();
        headers.append('uid', props.profile.uid);
        headers.append('Content-Type', 'application/json');
        setLoading(true);

        if (email === '') {
            alert('Please enter an email.');
            setLoading(false);
            return;
        }
        if (participantLimit === 'custom' && customParticipantLimit === '') {
            alert('Please enter a custom participant limit.');
            setLoading(false);
            return;
        }
        if (hostKey === '') {
            alert('Please enter a host key.');
            setLoading(false);
            return;
        }

        // Convert participant limit to integer
        const participantLimitInt = participantLimit === 'custom' ? parseInt(customParticipantLimit) : parseInt(participantLimit);
        
        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "zoomUserId": "",
                "email": email,
                "participantLimit": participantLimitInt,
                "hostkey": hostKey
            })
        };

        fetch(url, requestOptions)
            .then(response => {
                setLoading(false); // Reset loading state
                if (response.status === 201) {
                    alert('Zoom user added successfully.');
                    props.onUserAdded();
                } else {
                    alert('Error adding Zoom user.');
                }
            })
            .catch(error => {
                setLoading(false); // Reset loading state
                console.log(error);
            });
    }
    
    return (
        <div className="addUserForm">
            <Form>
                <h3>Add Zoom User</h3>

                <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={handleEmailChange}
                    />
                </Form.Group>

                <Form.Group controlId="hostKey">
                    <Form.Label>Host Key</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter host key"
                        value={hostKey}
                        onChange={handleHostKeyChange}
                    />
                </Form.Group>

                {/* Participant Limit Radio Buttons */}
                <fieldset>
                    <Form.Group>
                        <Form.Label as="legend">Participant Limit</Form.Label>
                        {['100', '300', '1000', 'custom'].map((limit) => (
                            <Form.Check
                                key={limit}
                                type="radio"
                                label={limit === 'custom' ? 'Custom' : limit}
                                name="participantLimitOptions"
                                id={`participantLimit${limit}`}
                                value={limit}
                                checked={participantLimit === limit}
                                onChange={handleParticipantLimitChange}
                            />
                        ))}
                    </Form.Group>
                </fieldset>

                {/* Custom Participant Limit Input */}
                {participantLimit === 'custom' && (
                    <Form.Group controlId="customParticipantLimit">
                        <Form.Label>Custom Participant Limit</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter custom limit"
                            value={customParticipantLimit}
                            onChange={handleCustomParticipantLimitChange}
                        />
                    </Form.Group>
                )}
            </Form>

            <Button className='saveButton' variant="dark" onClick={addZoomUser} disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
            </Button>
            {loading && <Spinner id='spinner' animation="border" role="status" />}        
        </div>
    );
}   

function AllZoomUsersList(props) {
    let url = baseUrl + '/api/zoomusers/';
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editUser, setEditUser] = useState(null);
    const [hostKey, setHostKey] = useState('');

    function deleteUser(userId) {
        if (!window.confirm('Are you sure you want to delete this user?')) {
            return;
        }

        const deleteUrl = baseUrl + '/api/zoomusers/' + userId;
        setLoading(true);
        const requestOptions = {
          method: 'DELETE',
          headers: {
            'uid': props.profile.uid,
            'Content-Type': 'application/json',
          },
        };
    
        fetch(deleteUrl, requestOptions)
          .then(response => {
            if (response.ok) {
              setUsers(prevUsers => prevUsers.filter(user => user.zoomUserId !== userId));
              alert('User deleted successfully.');
              props.onUserAdded();
            } else {
              throw new Error('Failed to delete user');
            }
            setLoading(false);
          })
          .catch(error => {
            setError(error);
            setLoading(false);
            alert('Failed to delete user');
          });
    }

    function editZoomUser(user) {
        setEditUser(user);
        setHostKey(user.hostKey || '');
    }

    function saveHostKey() {
        if (!editUser) return;
        const updateUrl = `${baseUrl}/api/zoomusers/addHostKey`;
    
        const requestOptions = {
            method: 'POST',
            headers: {
                'uid': props.profile.uid,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ "hostkey": hostKey, "uid": editUser.zoomUserId }),
        };
    
        fetch(updateUrl, requestOptions)
            .then(response => {
                if (!response.ok) throw new Error('Failed to update host key');
                setEditUser(null);
                alert('Host key updated successfully.');
                props.onUserAdded();
            })
            .catch(error => {
                alert('Failed to update host key');
            });
    }

    useEffect(() => {
        const headers = new Headers();
        headers.append('uid', props.profile.uid);
        headers.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'GET',
            headers: headers,
        };

        setLoading(true);
        
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                setUsers(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    }, [url, props.profile.uid, props.refreshTrigger]);

    return (
        <div className='allZoomUsersTable'>
            <h3>All Zoom Users</h3>
            <table>
                <thead>
                    <tr>
                        <th>S.no</th>
                        <th>Email</th>
                        <th>Participant Count</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => (
                        <tr key={user.zoomUserId}>
                            <td>{index + 1}</td>
                            <td>{user.email}</td>
                            <td>{user.participantLimit}</td>
                            <td>
                                <Button variant="primary" size="sm" className="me-2" onClick={() => editZoomUser(user)}>Edit</Button>
                                <Button variant="danger" size="sm" onClick={() => deleteUser(user.zoomUserId)}>Delete</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal show={!!editUser} onHide={() => setEditUser(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit: {editUser ? editUser.email : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formHostKey">
                            <Form.Label>Host Key</Form.Label>
                            <Form.Control type="text" value={hostKey} onChange={(e) => setHostKey(e.target.value)} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={saveHostKey}>Save</Button>
                    <Button variant="secondary" onClick={() => setEditUser(null)}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


function AllUsersList(props) {
    
        let url = baseUrl + '/api/users/';
        const [users, setUsers] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
    
        // fetch all users from the API once
        useEffect(() => {
            const headers = new Headers();
            headers.append('uid', props.profile.uid);
            headers.append('Content-Type', 'application/json');
    
            const requestOptions = {
                method: 'GET',
                headers: headers,
            }
    
            setLoading(true);
            
            fetch(url, requestOptions)
                .then(response => response.json())
                .then(data => {
                    setUsers(data);
                    console.log(data);
                    setLoading(false);
                })
                .catch(error => {
                    setError(error);
                    setLoading(false);
                });
        }
        , [url, props.profile.uid, props.refreshTrigger]);
    
        return (
            <div className='allUsersTable'>
        <h3>All Users</h3>
        <table>
            <thead>
                <tr>
                    <th>S.no</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Role</th>
                </tr>
            </thead>
            <tbody>
                {users.map((user, index) => (
                    <tr key={user.uid}>
                        <td>{index + 1}</td>
                        <td>{user.firstName}</td>
                        <td>{user.lastName}</td>
                        <td>{user.email}</td>
                        <td>{user.role}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
    
    
        );
}

export default AdminView;